import { updatePersonalDataPathFromCheckout } from 'app/services/businessFunctions/helpers/updatePersonalDataPathFromCheckout';

const onCheckoutFirstCoownerNameChange = {
  onCheckoutFirstCoownerNameChange() {
    updatePersonalDataPathFromCheckout();
  },
};

export default onCheckoutFirstCoownerNameChange;
